import {
  faChartBar,
  faCreditCard,
  faFileAlt,
} from '@fortawesome/free-regular-svg-icons';
import {
  faArrowRightFromBracket,
  faSignature,
} from '@fortawesome/free-solid-svg-icons';

import { PRO_MODE_ENABLED } from 'apps/shared/scripts/feature-gating/constants';
import useFeatureGate from 'apps/shared/scripts/feature-gating/hooks';

import SidenavItem from './SidenavItem';
import { sidenavListClassName } from './styles';

interface Props {
  hideMenu: () => void;
}

const SidenavList = (props: Props) => {
  const isProModeEnabled = useFeatureGate(PRO_MODE_ENABLED);

  return (
    <div className={sidenavListClassName}>
      <SidenavItem
        {...props}
        to="/dashboard/cards"
        faIcon={faFileAlt}
        label="Cards"
      />
      <SidenavItem
        {...props}
        to="/dashboard/signed"
        faIcon={faSignature}
        label="Signed"
      />
      {isProModeEnabled && (
        <SidenavItem
          {...props}
          to="/dashboard/billing"
          faIcon={faCreditCard}
          label="Billing"
        />
      )}
      <SidenavItem
        {...props}
        to="/dashboard/settings"
        faIcon={faChartBar}
        label="Settings"
      />
      <SidenavItem
        {...props}
        to="/logout"
        faIcon={faArrowRightFromBracket}
        label="Logout"
      />
    </div>
  );
};

SidenavList.displayName = 'SidenavList';

export default SidenavList;
